export default __webpack_public_path__ + "07e389f87599fb3fc568a9713f9221b0.png";